import EmptyView1 from '../../layouts/EmptyView1'
import UnderMaintenance from './UnderMaintenance'

export default EmptyView1(UnderMaintenance)
